<form #usuarioForm = ngForm>
  
<div class="body">
  
    <br/>
  
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Rut</p>
        </div>

        <div class="col-lg-6">

            <input id="rut" name="rut" class="form-control" [(ngModel)] = "afiliado.rut" [disabled]="afiliado.deshabilitado" type="text"  placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" required />

        </div>

        <div class="col-lg-2"> </div>



    </div>

    <br/>
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">                      
            <p>Nombres </p>
        </div>

        <div class="col-lg-6">
            
         
          
            <input id="nombres" name="nombres"  [(ngModel)] = "afiliado.nombres" [disabled]="afiliado.deshabilitado" required class="form-control"  />

        </div>

        <div class="col-lg-2"> </div>

    </div>
    <br/>

    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Apellido Paterno</p>
        </div>

        <div class="col-lg-6">
         
            <input id="apellidoPaterno" name="apellidoPaterno" [disabled]="afiliado.deshabilitado" [(ngModel)] = "afiliado.apellidoPaterno" class="form-control" type="text"  placeholder="Ingrese apellido Paterno del afiliado." required />

        </div>

        <div class="col-lg-2"> </div>

    </div>
    <br/>

    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Apellido Materno</p>
        </div>

        <div class="col-lg-6">

            <input id="apellidoMaterno" name="apellidoMaterno" [disabled]="afiliado.deshabilitado" [(ngModel)] = "afiliado.apellidoMaterno" class="form-control" type="text"  placeholder="Ingrese apellido Materno del afiliado." required />

        </div>

        <div class="col-lg-2"> </div>

    </div>
    <br/>


    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Fecha Nacimiento </p>
        </div>
        <div class="col-lg-5">
            <input class="form-control" name="fechaNacimiento" [disabled]="afiliado.deshabilitado" matInput type = "date" [(ngModel)] = "afiliado.fechaNacimiento"  type="date">
        </div>

        <div class="col-lg-3"> </div>

    </div>
    <br/>
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Sexo </label> </div>
        
        <div class="col-lg-5" >
            <p> 
                <input type="radio" name="sexo"  id="sexo" [(ngModel)]="afiliado.idSexo" [checked]="(afiliado.idSexo===1)" [value]="1" [disabled]="afiliado.deshabilitado"> Masculino &emsp;
            </p>
            <p>
                <input type="radio" name="sexo"  id="sexo" [(ngModel)]="afiliado.idSexo" [checked]="(afiliado.idSexo===2)"  [value]="2" [disabled]="afiliado.deshabilitado">Femenino
        </div>

    </div>
    <br/>
    
    <div class="row">

        <div class="col-lg-1"> </div>
    
        <div class="col-lg-3"> <label> Nacionalidad</label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="pais" #pais="ngModel" [(ngModel)]="afiliado.idNacionalidad" [disabled]="afiliado.deshabilitado">
                    <mat-option *ngFor="let estado of this.afiliado.nacionalidades" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <br/>

    <div class="row">

        <div class="col-lg-1"> </div>
    
        <div class="col-lg-3"> <label>Estado Civil</label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="civil" #civil="ngModel" [(ngModel)]="afiliado.idEstadoCivil" [disabled]="afiliado.deshabilitado">
                    <mat-option *ngFor="let estado of this.afiliado.estadoCivil" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>


    <div class="row">

        <div class="col-lg-1"> </div>
    
        <div class="col-lg-3"> <label>Sistema Salud</label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="salud" #salud="ngModel" [(ngModel)]="afiliado.idSistemaSalud" [disabled]="afiliado.deshabilitado" required>
                    <mat-option *ngFor="let estado of this.afiliado.sistemaSalud" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <br/>

    
</div>
</form>  